import { AlphaPIcon } from './AlphaPIcon';

/**
 * author: GreenTurtwig
 * id 750E27F3-36FF-423A-8AAD-F2FE833D9028
 * name alpha-p
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-p.svg
 * tags
 * - Automotive 
 * - Alpha / Numeric 
 */
export const LetterPIcon = AlphaPIcon;
export default LetterPIcon